import { FormEvent, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../util/axiosConfig";
import { useAuth } from "../../global/AuthContext";
import AuthLayout from "./AuthLayout";
import PasswordField from "./PasswordField";
import SocialLoginButtons from "../../component/SocialLoginButtons";
import { authError } from "./authFields";

export default function LoginPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const signup = location.state as { signupLoginId?: string } | null;
  const [loginId, setLoginId] = useState(signup?.signupLoginId || "");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const { completeLogin } = useAuth();
  const finish = async (token: string) => { await completeLogin(token); navigate("/", { replace: true }); };
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (busy) return;
    if (!loginId.trim() || !password) { setError("아이디와 비밀번호를 입력해주세요."); return; }
    setBusy(true); setError("");
    try {
      const res = await axios.post<{ token: string }>("/api/auth/login", { loginId: loginId.trim().toLowerCase(), password });
      await finish(res.data.token);
    } catch (err) { setError(authError(err)); } finally { setBusy(false); }
  };
  return <AuthLayout>
    <header className="auth-heading"><span>WELCOME BACK</span><h1>로그인</h1><p>팩트를 나누고, 함께 확인해요.</p></header>
    {signup?.signupLoginId && <p role="status" className="auth-success">회원가입이 완료되었습니다. 로그인해주세요.</p>}
    <form onSubmit={submit} className="auth-form">
      <fieldset disabled={busy}>
        <div className="auth-field"><label htmlFor="login-id">아이디 (이메일) <span className="auth-required">*</span></label><input id="login-id" type="email" placeholder="name@example.com" value={loginId} onChange={e => setLoginId(e.target.value)} autoComplete="username" autoCapitalize="none" spellCheck={false} maxLength={254} required /></div>
        <PasswordField id="login-password" label="비밀번호" value={password} onChange={setPassword} autoComplete="current-password" />
        {error && <p role="alert" className="auth-error">{error}</p>}
        <button className="auth-primary" type="submit">{busy ? "로그인 중…" : "로그인"}</button>
      </fieldset>
    </form>
    <p className="auth-switch">처음 방문하셨나요? <Link to="/signup">회원가입</Link></p>
    <div className="auth-divider"><span>또는 간편하게 시작하기</span></div>
    <SocialLoginButtons onLoginSuccess={finish} />
  </AuthLayout>;
}
